import type { ReactNode } from "react";
import { useAuth } from "@webmotors/consumer-shared-auth";
import { Header, Footer } from "@webmotors/consumer-shared-ui";
import { getPortalHost } from "@/utils";
import styles from "./layout.module.css";

type LayoutProps = {
  children: ReactNode;
};

export function Layout({ children }: Readonly<LayoutProps>) {
  const { token } = useAuth();
  const authToken = token ?? undefined;
  const portalBaseUrl = getPortalHost();

  return (
    <div className={styles.layout}>
      <Header authToken={authToken} />
      <main className={styles.main}>{children}</main>
      <Footer
        baseUrl={portalBaseUrl}
        enableCopiHelp
        enableCookieManagement
        copiAuthToken={authToken}
      />
    </div>
  );
}
